import styled from 'styled-components';

export const SidebarContainer = styled.aside`
	position: sticky;
	left: 0;
	top: 0;
	width: 30%;
	height: 100%;
	background: red;
	border: 1px solid #e0e0e0;
	border-radius: 5px;
	background: #fafafa;
	@media screen and (max-width: 1031px) {
		display: none;
	}
`;

export const SidebarWrapper = styled.section`
	padding: 16px;
`;

export const ReviewsWrapper = styled.div`
	padding: 8px;
	background: #fff;
	border: 1px solid #e0e0e0;
	border-radius: 5px;
`;

export const SectionWrapper = styled.section`
	margin-bottom: 16px;
`;
